<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-02-22 10:54:03
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2024-02-26 15:41:10
 * @FilePath: \front\src\views\Patient\components\special\components\sendDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  
    <el-dialog
			title="推送评估报告"
			:visible.sync="visible"
			width="30%"
			:close-on-click-modal="false"
            :before-close='closedialog'
			>
			<div style="text-align: center;">
				您确定将{{
                    info[type]
                }}推送至双佰康小程序？<br/>
				推送成功后，患者将能够在双佰康小程序中查看并遵循{{ info[type] }}
			</div>
			
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sendHandle">确定推送</el-button>

				<el-button @click="closedialog">取 消</el-button>
			</span>
		</el-dialog>
</template>

<script>
import api from '@/service/api';
import { EventBus } from '@/event-bus.js';

export default {
    props:{
        dialogVisible:{
            type:Boolean,
        },
        type:{
            type:String,
        },
        evalId:{
            required:true,
        }
    },
    data(){
        return{
            visible:true,
            info:{
               2:'心理评估',
               3:'中医评估',
               4:'入院评估',
               5:'运动评估',
               6:'饮食评估',
               7:'睡眠评估',
               
            }
        }
    },
    created(){
    },
    methods:{
        async sendHandle(){
            let res=await api.pushEval({evalId:this.evalId});
            if(res.code==1000){
                EventBus.$emit('update-eval-data')
                this.$message.success('推送成功');
            }else{
                this.$message.error('推送失败');

            }
            this.$emit("update:dialogVisible", false);

        },
        closedialog(){
			this.$emit("update:dialogVisible", false);

        },
        // async getPushState(){
        //     let res=await api.getEvalPushState({evalId:this.evalId});
        //     if(res.code==1000){
                
        //     }
        // }
    }
}
</script>

<style>

</style>